import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createSelfProvisionWA, resetWaitingAreaForm } from '../../../../actions/waitingArea';
import { getUserBasicProfile } from '../../../../actions/user';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import { forceValidation } from '../../../../businessLogic/validation.js';
import { trimSlashAtTheEnd } from 'businessLogic/selfProvision.js';
import { hideGlobalMessage } from '../../../../actions/globalMessage';
import { updateShowRegisterUserWithWA, updateShowWelcomeWAMessage } from '../../../../actions/modal';
import { redirectToInternalLink } from 'businessLogic/redirector.js';
import Info from '../../info';
import { selectWaitingArea, getWaitingArea } from '../../../../actions/waitingArea';

export default function RightPanel(props) {
  const dispatch = useDispatch();
  const [isWASelfProvisionSaving, setIsWASelfProvisionSaving] = useState(false);

  const updateWASelfProvision = (e) => {
    let areThereErrors = forceValidation(undefined, undefined, 'selfProvisionWAForm');
    if (!areThereErrors && !e.target.classList.value.includes('disable')) {
      if (isWASelfProvisionSaving) {
        return; //already a reques is in process
      }
      let cb = (result, response) => {
        let gotUserBasicProfile = () => {
          dispatch(updateShowWelcomeWAMessage(true));
          // we will only redirect once we have the basic info response
          // this means we will not ending up the user seeing page not found
          resetForm();
          setIsWASelfProvisionSaving(false);
          redirectToInternalLink('/waiting-area/view-one/' + response.networkId);
        };
        if (result) {
          //as the waiting area is created for existing user, we will now set the waiting area id
          dispatch(selectWaitingArea(response.networkId));
          queueESEvents(
            ESEventTypes.APICall,
            `In updateWASelfProvision: ${response.networkId}`,
            'eventType&apiURL',
            {
              apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + response.networkId + '/calls',
              browserURL: window.location.href,
            },
            null,
            true,
            'info'
          );
          dispatch(getWaitingArea(response.networkId));
          const authRes = response.authenticationResponse;
          //Reload the basicinfo and in success cb we will do the following:
          dispatch(getUserBasicProfile(gotUserBasicProfile));
        } else {
          setIsWASelfProvisionSaving(false);
        }
      };

      setIsWASelfProvisionSaving(true);

      let selfProvisionWA = props.selfProvisionCreateForm;
      // remove the trailing slash before saving
      let waitingAreaUrl = selfProvisionWA.waitingAreaUrl;
      selfProvisionWA.waitingAreaUrl = trimSlashAtTheEnd(waitingAreaUrl);
      dispatch(createSelfProvisionWA(selfProvisionWA, cb));
    }
  };

  const cancelWASelfProvision = () => {
    if (isWASelfProvisionSaving) {
      //when saving we dont want to cancel
      return;
    }
    if (document.getElementsByClassName('global-message color-bad-things-bg').length > 0) dispatch(hideGlobalMessage());
    resetForm();
  };

  const resetForm = () => {
    dispatch(updateShowRegisterUserWithWA(false));
    dispatch(resetWaitingAreaForm());
  };

  let saveClasses =
    'ui  labeled icon button icon left-text color-button color-button-hover color-white max-width  mrlnull mrbnull disable';
  let cancelClass =
    'ui  labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull';
  return (
    <div>
      <div className="ui actions mrbl max-width noTopMarginTablet">
        <button
          tabIndex="5"
          type="button"
          onClick={updateWASelfProvision}
          data-group="selfProvisionWAForm"
          className={isWASelfProvisionSaving ? saveClasses + ' loading' : saveClasses}
        >
          {APP.LANGUAGE.Save}
          <i className="checkmark  icon" />
        </button>
        <button
          tabIndex="6"
          type="button"
          onClick={cancelWASelfProvision}
          className={isWASelfProvisionSaving ? cancelClass + ' disable' : cancelClass}
        >
          <i className="remove  icon" />
          {APP.LANGUAGE.Cancel}
        </button>
      </div>
      <div className="mrtl">
        <Info
          paragraphs={[APP.LANGUAGE.SelfProvisionCreateWA.DetailPart1, APP.LANGUAGE.SelfProvisionCreateWA.DetailPart2]}
        />
      </div>
    </div>
  );
}
